import { css } from 'styled-components';
import {
  BreakpointQueryName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const descriptionStyle: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    ${getSpacing.paddingTop(theme, SpacingName.SMALL)};
  }
`;
